export const getDefaultMetadataMapping = () => [
  {
    db_field: null,
    flow_input_field: "grouping_id",
  },
  {
    db_field: null,
    flow_input_field: "version",
  },
];

export const DELETED_VERSION_NAME = "Deleted version";
